<template>
    <div>
       <div style="margin-left:8px;border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-right: 4px;padding-bottom: 6px;height: 90vh;margin-bottom:50px;">
           <div style="display: flex;flex-wrap: wrap;">

               <div style="background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;height:82vh;padding: 0px 30px; overflow: auto;">
                   <div style="">

                       <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 10px; font-size: 15px;font-weight: 900;">offer基本信息</div>
                       <el-progress :percentage="100"></el-progress>

                       <div style="display: flex;margin-top: 30px; justify-content: space-between;">
                           <div style="width: 33%; ">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">招聘负责人</div>
                               <div style="">
                                   <el-input :disabled="isDisabled" v-model="resumeNumber1" type="text" show-word-limit maxlength="4" placeholder="请输入招聘负责人"></el-input>
                               </div>
                           </div>

                           <div style="width: 33%; ">
                               <div style="text-align: start;margin-bottom: 10px;font-weight: 900;">发放时间</div>
                               <el-date-picker style="width: 100%;" :disabled="isDisabled"  v-model="resumeNumber2" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                           </div>

                           <div style="width: 33%;">
                               <div style="text-align: start;margin-bottom: 10px;font-weight: 900;">候选人姓名</div>
                               <div style="">
                                    <el-input :disabled="isDisabled" v-model="resumeNumber3" type="text" show-word-limit maxlength="4" placeholder="请输入候选人姓名"></el-input>
                               </div>
                           </div>
                       </div>


                       <div style="display: flex;margin-top: 30px; justify-content: space-between;flex-wrap: wrap;">

                           <!-- <div style="width: 33%;margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">offer岗位</div>
                               <div style="">
                                   <el-select :disabled="isDisabled" style="width: 100%" filterable  v-model="resumeNumber4" autocomplete="off" placeholder="请选择科目" clearable>
                                       <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                       :value="jobStatu.jobId"></el-option>
                                   </el-select>
                               </div>
                           </div> -->

                           <div style="width: 33%;margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">手机号</div>
                               <div style="">
                                   <el-input :disabled="isDisabled" v-model="resumeNumber5" type="text" show-word-limit maxlength="11" placeholder="请输入手机号"></el-input>
                               </div>
                           </div>

                           <div style="width: 33%;margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">入职部门</div>
                               <div style="">
                                   <el-select :disabled="isDisabled" style="width: 100%" filterable  v-model="resumeNumber6" autocomplete="off" placeholder="请选择科目" clearable>
                                       <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                       :value="jobStatu.jobId"></el-option>
                                   </el-select>
                               </div>
                           </div>

                           <div style="width: 33%;margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">是否住宿</div>
                               <div style="">
                                   <el-select :disabled="isDisabled" style="width: 100%" filterable  v-model="resumeNumber7" autocomplete="off" placeholder="请选择科目" clearable>
                                       <el-option v-for="jobStatu in jobss" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                       :value="jobStatu.jobId"></el-option>
                                   </el-select>
                               </div>
                           </div>


                           <div style="width: 33%;margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">报道日期</div>
                               <div style="">
                                   <el-date-picker style="width: 100%;" :disabled="isDisabled" v-model="resumeNumber8" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                               </div>
                           </div>

                           <div style="width: 33%;margin-bottom: 30px;">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">邮箱</div>
                               <div style="">
                                   <el-input :disabled="isDisabled" v-model="resumeNumber9" type="text" show-word-limit maxlength="30" placeholder="请输入邮箱"></el-input>
                               </div>
                           </div>

                           <div style="width: 33%;margin-bottom: 30px;">

                           </div>

                       </div>


                       <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 30px; font-size: 15px;font-weight: 900;">跟进结果</div>
                       <el-progress :percentage="100"></el-progress>

                       <div style="display: flex;margin-top: 30px; justify-content: space-between;flex-wrap: wrap; justify-content: space-between;">

                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;" :class="SbutSuccess ? 'noclick' : '' ">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">offer状态</div>
                               <div style="display: flex;" v-if="initIsDis === 'no' ">
                                   <el-select :disabled=" types === '详情' " ref="select"  @change="handdleClickCurrue"  placeholder="请选择offer状态" v-model="resumeNumber10" style="width: 100%" clearable filterable>
                                       <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname">
                                             <span style="padding: 5px 10px; background: #e76211;border-radius: 8px; color: #fff; " v-if="item.id === 1">{{ item.realname }}</span>
                                             <span style="padding: 5px 10px; background: rgb(200 17 231);border-radius: 8px; color: #fff; " v-if="item.id === 0">{{ item.realname }}</span>
                                             <span style="padding: 5px 10px; background: rgb(94 213 8);border-radius: 8px; color: #fff; " v-if="item.id === 2">{{ item.realname }}</span>
                                       </el-option>
                                   </el-select>
                               </div>
                               <div style="display: flex;" v-if="initIsDis === 'off' ">
                                   <el-select :disabled="true"  @change="handdleClickCurrue" ref="select1" placeholder="请选择offer状态" v-model="resumeNumber10" style="width: 100%" clearable filterable>
                                       <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname">
                                             <span style="padding: 5px 10px; background: #e76211;border-radius: 8px; color: #fff; " v-if="item.id === 1">{{ item.realname }}</span>
                                             <span style="padding: 5px 10px; background: rgb(200 17 231);border-radius: 8px; color: #fff; " v-if="item.id === 0">{{ item.realname }}</span>
                                             <span style="padding: 5px 10px; background: rgb(94 213 8);border-radius: 8px; color: #fff; " v-if="item.id === 2">{{ item.realname }}</span>
                                       </el-option>
                                   </el-select>
                               </div>
                           </div>

                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;" v-if="initIsDis === 'no' ">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">备注</div>
                               <div style="display: flex;">
                                <el-input :disabled=" types === '详情' "  v-model="resumeNumber11" type="text" show-word-limit maxlength="100" placeholder="请输入备注"></el-input>
                               </div>
                           </div>
                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;" v-if="initIsDis === 'off' ">
                               <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">备注</div>
                               <div style="display: flex;">
                                <el-input :disabled="true"  v-model="resumeNumber11" type="text" show-word-limit maxlength="100" placeholder="请输入备注"></el-input>
                               </div>
                           </div>

                           <div style="width: 30%;padding-left: 10px;margin-top: 10px;">

                           </div>

                       </div>


                   </div>
               </div>

               <div style="width: 100%;background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding: 10px 0px;display: flex;justify-content: end; padding-right: 25px;">
                    <span slot="footer" class="dialog-footer" v-if="initIsDis === 'no' ">
                        <el-button size="small" @click="handleShowAddTemplateDialogSubs">返 回</el-button>
                        <el-button v-if=" types !== '详情' " size="small" type="primary" @click="handleShowAddTemplateDialogSub">提 交</el-button>
                    </span>
                    <span slot="footer" class="dialog-footer" v-if="initIsDis === 'off' ">
                        <el-button  size="small" @click="handleShowAddTemplateDialogSubs">返 回</el-button>
                    </span>
               </div>

           </div>

       </div>

       <div class="box"  v-if="uploadShowDlong">
               <div style="position: absolute; top: 14px;right: 25px;font-size: 20px;"><i class="el-icon-close"  @click="uploadShowDlongCler"></i></div>
               <el-upload class="upload-demo" style="height: 350px;"
                   drag
                   action="#"
                   :on-remove="handleRemove"
                   :beforeUpload="beforeUpload"
                   :http-request="handleUpload"
                   :on-error="handleError"
                   :auto-upload="true"
                   :limit="1"
                   show-file-list
                   :file-list="fileDataList">
                   <i class="el-icon-upload"></i>
                   <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
               </el-upload>
               <div slot="footer" class="dialog-footer">
                   <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="uploadShowDlongCler">取消</el-button>
                   <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="uploadShowDlongSub">保存</el-button>
               </div>
        </div>




        <div class="box1"  v-if="ShowCurrentComponentDialog">
            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding-bottom: 6px;">
                <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="handleShowCurrentComponentDialogClose"><i class="el-icon-close"></i> </div>
                <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px;">入职填报</div>
            </div>
            <div>
                <component :is="currentComponent" @handleEventChildren="handleEventChildren" :RowData="RowData" :initObj="initObj" :resumesId="resumesId"></component>
            </div>
        </div>




    </div>
</template>


   <script>
   import axios from "axios";
   import apiBaseUrl from "../../../config/api";
   import loadingUtils from "../../utils/loading";
   import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
   import employmentComponents from "./employmentComponents";

   export default {
       components: { employmentComponents },

       props:{
          resumesId:{
             type:String,
             default:'',
          },
          initObj:{
             type:Object,
             default: {},
          },
          types:{
             type:String,
             default: '',
          },
       },

       data(){
           return{

               jobs:[],
               isDisabled: false,


               resumeNumber1: '',
               resumeNumber2: '',
               resumeNumber3: '',
               resumeNumber4: '',
               resumeNumber5: '',
               resumeNumber6: '',
               resumeNumber7: '',
               resumeNumber8: '',
               resumeNumber9: '',
               resumeNumber10: '',
               resumeNumber11: '',

               optionList2:[{id:1,realname:'拒接offer'},{id:0,realname:'待入职'},{id:2,realname:'已入职'}],


               uploadShowDlong: false,
               fileDataList:[],


               jobss:[{jobId:1, jobName:'是'},{jobId:2, jobName:'否'}],
               resumeNumber3Url: '',


               ShowCurrentComponentDialog:false,
               currentComponent:'',

               initIsDis:'no',
               RowData: null,

               SbutSuccess: false,
           }
       },

       mounted(){

          if(this.initObj){

             this.isDisabled = true
             this.resumeNumber1 = this.initObj.interviewerName
             this.resumeNumber2 = this.initObj.sendDate
             this.resumeNumber3 = this.initObj.name
            //  this.resumeNumber4 = this.initObj.deptName
             this.resumeNumber5 = this.initObj.telPhone
             this.resumeNumber6 = this.initObj.deptName
             this.resumeNumber7 = this.initObj.isStay === 1 ? '否' : '是'
             this.resumeNumber8 = this.initObj.reportTime
             this.resumeNumber9 = this.initObj.email
          }

           axios.get(`${apiBaseUrl}/teacher/query/job`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {this.jobs = res.data.data.list})


           axios.get(`${apiBaseUrl}/resumes-offer/findOfferInfo/${this.resumesId}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {

                if(res.data.code == 200){
                    let data = res.data.data
                    this.resumeNumber10 = data.offerStatus
                    this.resumeNumber11 = data.remark

                    this.RowData = data

                    if(this.resumeNumber10 === 2){
                       this.initIsDis = 'off'
                    }else{
                       this.initIsDis = 'no'
                    }
                }else{
                    this.$message({type: 'error', message: res.data.msg })
                }
           })

       },


       methods:{

            handleEventChildren(event,type){
                if(type === 'success'){
                    this.SbutSuccess = true
                }else{
                    this.SbutSuccess = false
                }
                this.currentComponent = ''
                this.ShowCurrentComponentDialog = event
            },


            handleShowCurrentComponentDialogClose(){
                this.currentComponent = ''
                this.ShowCurrentComponentDialog = false
            },

           handdleClickCurrue(e){
             if(e === 2){
                this.currentComponent = 'employmentComponents'
                this.ShowCurrentComponentDialog = true
             }
           },

           handleGetApiModifyOffer(){
                let data = { offerStatus: this.resumeNumber10 , remark: this.resumeNumber11 }
                axios.post(`${apiBaseUrl}/resumes-offer/modifyOffer/${this.resumesId}`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                    if(res.data.code == 200){
                        this.$message({type: 'success', message: '添加成功'})
                        this.$emit('handleEventChildren', false)
                    }else{
                        this.$message({type: 'error', message: '添加失败' })
                    }
                }).catch((err)=>{
                    this.$message({type: 'error', message: 'message No message available' })
                })
           },

           handleShowAddTemplateDialogSub(){
              this.handleGetApiModifyOffer()
            //   this.$emit('handleEventChildren', false)
           },
           handleShowAddTemplateDialogSubs(){
              this.$emit('handleEventChildren', false)
           },

           handleShowUpload(){
               this.fileDataList = []
               this.uploadShowDlong = true
           },

           uploadShowDlongCler(){
               this.fileDataList = []
               this.uploadShowDlong = false

           },

           uploadShowDlongSub(){
               this.resumeNumber3 = this.fileDataList[0].name
               this.resumeNumber3Url = this.fileDataList[0].url
               this.uploadShowDlong = false
           },


           handleShowView(){

           },



           handleRemove(file, fileList){
               this.fileDataList = fileList
           },

           getFileName(name) {
                return name.substring(name.lastIndexOf("."))
           },

           beforeUpload(file, fileList){
               loadingUtils.startLoading()
               const fileExtensions =
                   this.getFileName(file.name) === ".bmp" ||
                   this.getFileName(file.name) === ".tif" ||
                   this.getFileName(file.name) === ".gif" ||
                   this.getFileName(file.name) === ".pcx" ||
                   this.getFileName(file.name) === ".svg" ||
                   this.getFileName(file.name) === ".psd" ||
                   this.getFileName(file.name) === ".webp" ||
                   this.getFileName(file.name) === ".apng" ||
                   this.getFileName(file.name) === ".ai" ||
                   this.getFileName(file.name) === ".avif" ||
                   this.getFileName(file.name) === ".png" ||
                   this.getFileName(file.name) === ".pdf"||
                   this.getFileName(file.name) === ".mp4"||
                   this.getFileName(file.name) === ".excel"||
                   this.getFileName(file.name) === ".doc"||
                   this.getFileName(file.name) === ".ppt"||
                   this.getFileName(file.name) === ".mp3"||
                   this.getFileName(file.name) === ".xls"||
                   this.getFileName(file.name) === ".xlsx"||
                   this.getFileName(file.name) === ".pptx"||
                   this.getFileName(file.name) === ".docx"||
                   this.getFileName(file.name) === ".txt"||
                   this.getFileName(file.name) === ".jpg";
               const max20M = file.size / 1024 / 1024 < 1000;

               if (!fileExtensions) {
                this.$message({type: 'warning', message: '上传文件类不合格式' })
               }
               if (!max20M) {
                this.$message({type: 'warning', message: '上传文件类不合格式' })
               }

               return fileExtensions && max20M
           },

           handleUpload(option){
               let obj = option.file.name
               let index = obj.lastIndexOf(".")
               obj = obj.substring(index, obj.length)
               let objName = option.file.name
               put(`mz_pc/${objName}`, option.file).then((res) => {
                   loadingUtils.endLoading()

                   let replacedStr = res.name.replace("mz_pc/", "")
                   res.name =  replacedStr

                   this.fileDataList.push(res)

                   signatureUrl(`mz_pc/${objName}`).then((res) => {})
               });
           },


           handleError(){
               loadingUtils.endLoading()
           },



           handleDelet(){
               this.resumeNumber3 = ''
               this.resumeNumber3Url = ''
           },


       },



   }


   </script>

   <style lang="less" scoped>
        .btns{
           background-color: #428BCA;
           border-color: #428BCA;
           color: #fff;
       }

       .box{
           position: fixed;
           background: #fff;
           width: 50%;
           z-index: 1111;
           top: 160px;
           left: 26%;
           height: 50vh;
           margin: 0;
           padding-top: 70px;
           border: 1px solid #d5d0d0;
           border-radius: 10px;
       }


       .box1{
            position: fixed;
            background: #f3f3f3;
            width: 100%;
            z-index: 1111;
            top: 0;
            left: 0;
            height: 100vh;
            margin: 0;
       }

       .noclick{
           pointer-events: none;
       }

       /deep/ .el-progress__text{
            opacity: 0;
       }

   </style>



// WEBPACK FOOTER //
// src/InterviewManagement/components/grantComponents.vue